export default "__VITE_ASSET__30f0c62d__"